module.exports = __webpack_public_path__ + "img/adventage.b47e3709.png";